<template>
    <q-card class="bg-grey-1">
        <q-card-media :class="liveClassBlocked ? 'disable-image' : ''" @click="goLiveClass()">
            <img :src="live_class.image_small" v-if="live_class.image_small">
            <img :src="getPlaceholder" v-if="!live_class.image_small">
        </q-card-media>

        <q-card-main class="relative-position">
            <div class="line-card bg-primary absolute-top"></div>

            <div class="row q-my-sm">
                <div class="col-12" @click="goToLiveClass()">
                    <div class="row">
                        <div class="col-12 q-title text-weight-medium" :class="liveClassBlocked ? 'text-faded' : 'text-primary'">
                            {{ live_class.title }}
                        </div>

                        <div class="col-12 q-subheading text-weight-regular" :class="liveClassBlocked ? 'text-faded' : 'text-primary'">
                            {{ $t('live_class_date') }} {{ fDate(live_class.date) }} {{ `(${live_class.timezone})` }}
                        </div>
                    </div>
                </div>

                <div class="col-12">
                    <div class="row gutter-sm">
                        <div class="col-6">
                            <p class="caption" v-if="live_class.areas.length > 0">
                                {{ $t('areas') }}
                            </p>
                            <p v-if="live_class.areas.length > 0" class="tooltip q-mb-sm">
                                <span v-for="(area, index) in live_class.areas" :key="index">
                                    {{ getArea(area) }}<span v-if="(live_class.areas.length - 1) > index">, </span>
                                </span>
                            </p>
                        </div>

                        <div class="col-6">
                            <p class="caption" v-if="live_class.tags.length > 0">
                                {{ $t('tags') }}
                            </p>
                            <p class="tooltip q-mb-sm">
                                <span v-for="(tag, index) in live_class.tags" :key="index">
                                    {{ getTag(tag) }}<span v-if="(live_class.tags.length - 1) > index">, </span>
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </q-card-main>

        <q-card-separator v-if="showSubscribeButton" />

        <q-card-actions v-if="showSubscribeButton">
            <q-btn :color="getSubscribeButtonColor" class="full-width" :label="$t(getSubscribeButtonLabel)" :icon="getSubscribeButtonIcon" :disable="!has_vacancy" @click="subscribeLiveClass()" />
        </q-card-actions>
    </q-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { colors } from 'quasar'
import { date } from 'quasar'
const { getDateDiff, formatDate } = date

export default {
    props: ['live_class'],

    data() {
        return {
            selected_client_params: [],
            sections: [],
            has_vacancy: false
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            all_tags: 'site_lists/tags',
            all_areas: 'site_lists/country_areas',
            group_users: 'site_lists/group_users_labels',
            clients: 'params/clients',
            params_loaded: 'params/params_loaded',
			id_user_client_selected: 'common/id_user_client_selected',
            id_user_language_selected: 'common/id_user_language_selected',
            user_id: 'common/id',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getPlaceholder() {
            if (!this.selected_client_params.live_class_placeholder) return ''
            else return this.selected_client_params.live_class_placeholder
        },

        liveClassBlocked() {
            let diff = date.getDateDiff(this.live_class.date, new Date(), 'minutes')

            if (this.live_class.users_subscribed && diff <= 30) return false
            else return true
        },

        showSubscribeButton() {
            let diff = date.getDateDiff(this.live_class.date, new Date(), 'minutes')

            if (this.live_class.type === 1) {
                if (diff <= -15) return false
                else return true
            } else {
                return false
            }

        },

        getSubscribeButtonLabel() {
            if (!this.live_class.users_subscribed && !this.has_vacancy) return 'no_vacancy'
            if (!this.live_class.users_subscribed && this.has_vacancy) return 'subscribe'
            else return 'unsubscribe'
        },

        getSubscribeButtonIcon() {
            if (!this.live_class.users_subscribed && !this.has_vacancy) return 'fas fa-users-slash'
            if (!this.live_class.users_subscribed && this.has_vacancy) return 'fas fa-sign-in-alt'
            else return 'fas fa-sign-out-alt'
        },

        getSubscribeButtonColor() {
            if (!this.live_class.users_subscribed && this.has_vacancy) return 'primary'
            else return 'tertiary'
        }
    },

    methods: {
        checkHasVacancy() {
            if(this.live_class.number_of_subscribers < this.live_class.qty_limit) this.has_vacancy = true
            else this.has_vacancy = false
        },

        getArea(id) {
            let obj = this.all_areas.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        getTag(id) {
            let obj = this.all_tags.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        getGroup(id) {
            let obj = this.group_users.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        goToLiveClass() {
            if (!this.liveClassBlocked) this.$router.push({ name: 'live_class', params: { id: this.live_class.id } })
        },

        subscribeLiveClass() {
            this.$emit('subscribe_live_class')
            this.checkHasVacancy()
        },

        fDate(d) {
            let format = ''

            switch(this.id_user_language_selected) {
                case 1:
                case 3: format = 'DD/MM/YYYY HH:mm:ss'
                break
                default: format = 'MM-DD-YYYY HH:mm:ss'
                break
            }
            return date.formatDate(d, format)
        }
    },

	created() {
        this.checkHasVacancy()
        this.selected_client_params = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
	}
}
</script>

<style lang="stylus" scoped>
.line-card
    border-top: 3px solid transparent
    border-top-left-radius inherit
    border-top-right-radius inherit

p
    margin 0 0 5px

.training-thumb
    width 90%
    height auto
    border-radius 10px
</style>
